import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any */
import { TextProps } from '#components/chart/types';
import { formatValue } from '#components/chart/utils';
type LineLabelProps = {
  textProps?: TextProps<{
    index: number;
    value: number;
  }>;
} & {
  [key: string]: any;
};
export const LineLabel = props => {
  const $ = _c(26);
  let index;
  let rest;
  let textProps;
  let value;
  if ($[0] !== props) {
    const {
      value: t0,
      index: t1,
      textProps: t2,
      parentViewBox,
      textBreakAll,
      content,
      viewBox,
      ...t3
    } = props;
    value = t0;
    index = t1;
    textProps = t2;
    rest = t3;
    $[0] = props;
    $[1] = index;
    $[2] = rest;
    $[3] = textProps;
    $[4] = value;
  } else {
    index = $[1];
    rest = $[2];
    textProps = $[3];
    value = $[4];
  }
  if (value === undefined || value === null) {
    return null;
  }
  let t0;
  if ($[5] !== index || $[6] !== textProps || $[7] !== value) {
    t0 = typeof textProps === "object" ? textProps : textProps?.({
      value,
      index
    }) || {};
    $[5] = index;
    $[6] = textProps;
    $[7] = value;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let descriptorText;
  let forceShow;
  let hideLabel;
  let other;
  if ($[9] !== t0) {
    ({
      hideLabel,
      forceShow,
      descriptorText,
      ...other
    } = t0);
    $[9] = t0;
    $[10] = descriptorText;
    $[11] = forceShow;
    $[12] = hideLabel;
    $[13] = other;
  } else {
    descriptorText = $[10];
    forceShow = $[11];
    hideLabel = $[12];
    other = $[13];
  }
  if (hideLabel) {
    return null;
  }
  let t1;
  if ($[14] !== descriptorText) {
    t1 = descriptorText && <tspan className="font-normal">{descriptorText} </tspan>;
    $[14] = descriptorText;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== value) {
    t2 = formatValue(value);
    $[16] = value;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== t2) {
    t3 = <tspan className="font-bold">{t2}</tspan>;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== forceShow || $[21] !== other || $[22] !== rest || $[23] !== t1 || $[24] !== t3) {
    t4 = <text {...rest} className="mix-blend-multiply" textAnchor="middle" data-force-show={forceShow} {...other}>{t1}{t3}</text>;
    $[20] = forceShow;
    $[21] = other;
    $[22] = rest;
    $[23] = t1;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};